import { Button, Card } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import updateProductionTodo from "astrid-firestore/src/api/productions/todos/updateProductionTodo";
import { ProductionTodo } from "astrid-firestore/src/api/productions/types/ProductionTodo";

import Flex from "../../../../../components/Flex/Flex";
import { useProfile } from "../../../../authentication/state/profile";
import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function ProductionTodoEditContent({ todo, onSuccess, onCancel }) {
	const { t } = useTranslation();
	const user = useProfile();

	const { form, onSubmit, formState, error } = useSimpleForm({
		schema: ProductionTodo,
		defaultValues: {
			text: todo.text || "",
		},
		onSubmit: ({ text }) => {
			if (text.trim() !== todo.text) {
				return updateProductionTodo(firebase, {
					todo,
					text: text.trim(),
					updatedBy: user,
				});
			}
		},
		onSuccess,
	});

	return (
		<Card.Content>
			<Form form={form}>
				<Flex gap={5}>
					<div style={{ flex: 1 }}>
						<Form.Input name="text" style={{ flex: 1, marginBottom: 0 }} />
					</div>

					<Button onClick={onCancel}>{t("cancel", "Cancel")}</Button>

					<Button onClick={onSubmit} loading={formState.isSubmitting} disabled={!form.watch("text")?.trim()}>
						{t("save", "Save")}
					</Button>
				</Flex>
			</Form>

			{error && <ErrorMessage error={error} />}
		</Card.Content>
	);
}
